<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"/>
  </div>
</template>
<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f5f5f5;
  font-family: '微软雅黑';
}
.fix {
  zoom: 1;
}
ul,li {
  list-style: none;
}

.fix:after {
  display: table;
  content: "";
  clear: both;
}
.font-big {
  font-size: 20px;
}

button {
  cursor: pointer;
}

button:focus {
  outline: none;
}

/*scrollbar*/

::-webkit-scrollbar {
  width: 17px;
  height: 17px;
}

::-webkit-scrollbar-track-piece {
  background-color: #f6f7f9;
  border: 2px solid #fff;
}

::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border: 3px solid #f6f7f9;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
}

.ui-jqgrid-bdiv:hover::-webkit-scrollbar-thumb {
  background-color: #ccc;
}

.ui-scroll {
  overflow: auto;
}

.ui-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.ui-scroll::-webkit-scrollbar-track-piece {
  border-radius: 12px;
  background-color: #e5e5e5;
  border: 1px solid #f6f7f9;
}

.ui-scroll::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 12px;
  border-width: 1px;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.ui-scroll::-webkit-scrollbar-thumb:hover {
  background-color: #999;
}

.ui-scroll:hover::-webkit-scrollbar-thumb {
  background-color: #999;
}
</style>
